module.exports = "<p>\n  linkedin-login-button works!\n</p>\n"